import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Flame, Wrench, Thermometer, ShieldCheck, Phone, Droplets, ArrowRight } from 'lucide-react';
import { services } from '../data/services';
const iconMap = {
  Flame,
  Wrench,
  Thermometer,
  ShieldCheck,
  Phone,
  Droplets
};
export function Services() {
  return <section id="services" className="py-24 relative z-10 bg-[#0a0a0a]" data-id="element-229" data-mp="18xalw0vcvqt9">
      <div className="max-w-7xl mx-auto px-6" data-id="element-230" data-mp="13x5zxvboi3vn">
        <div className="text-center mb-16" data-id="element-231" data-mp="z4mnx2sn3gsy">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[#FFD600] font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-232" data-mp="z3l86l0oi64w">
            Our Services
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-black text-white" data-id="element-233" data-mp="g8dbsl1at0bl">
            Complete Heating Solutions
          </motion.h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-234" data-mp="3q0ync4yial7q">
          {services.map((service, index) => {
          const Icon = iconMap[service.iconName];
          return <motion.div key={service.slug} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.08
          }} data-id="element-235" data-mp="3g1rf1w6mpgrh" data-mpi={index}>
                <Link to={`/services/${service.slug}`} className="group relative bg-brand-card rounded-2xl overflow-hidden border border-white/5 hover:border-[#FF9500]/30 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_10px_40px_-10px_rgba(255,149,0,0.15)] block h-full" data-id="element-236" data-mp="1lir06iq66wbn">
                  <div className="aspect-video overflow-hidden bg-black" data-id="element-237" data-mp="16v625385jnal">
                    <img src={service.heroImage} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-238" data-mp="11u8hmjzo6h5x" />
                    <div className="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-black/40 to-transparent pointer-events-none" data-id="element-239" data-mp="sw6cbs8wl2cu"></div>
                  </div>

                  <div className="p-7 relative" data-id="element-240" data-mp="2n95wlyo8akqg">
                    <div className="absolute -top-7 left-7 w-14 h-14 rounded-full bg-gradient-primary p-[1px] shadow-lg" data-id="element-241" data-mp="2urdj8q6cw8hy">
                      <div className="w-full h-full bg-brand-card rounded-full flex items-center justify-center" data-id="element-242" data-mp="2zpotv34h6n18">
                        <Icon className="w-6 h-6 text-[#FF9500]" data-id="element-243" data-mp="34i87u172rk6k" />
                      </div>
                    </div>
                    <div className="pt-8" data-id="element-244" data-mp="39fql23s4klkd">
                      <h3 className="text-xl font-bold text-white mb-3" data-id="element-245" data-mp="2bsrhra6xgfdi">
                        {service.title}
                      </h3>
                      <p className="text-gray-400 mb-5 leading-relaxed text-sm" data-id="element-246" data-mp="2gsduliiuftls">
                        {service.shortDescription}
                      </p>
                      <span className="inline-flex items-center gap-2 text-[#FFD600] font-semibold text-sm group-hover:gap-3 transition-all" data-id="element-247" data-mp="2ps0yqc2yjdij">
                        Learn more <ArrowRight className="w-4 h-4" data-id="element-248" data-mp="zwzhaixsjwg" />
                      </span>
                    </div>
                  </div>
                </Link>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}